import React from "react";

import {
  ExpandIcon as Expand,
  ListIcon as List,
  TreeIcon as Tree
} from "@packages/ds";

import {
  TableTreeButton,
  TableTreeDefaultButton
} from "../components/ProcessesButtons";
import { SearchInput } from "../components/SearchInput";
import { ProcessListMode } from "../ProcessList";

import * as S from "./ListFilters.styles";

export type ListFiltersProps = {
  selected: ProcessListMode;
  fullScreen: boolean;
  onChange: (selected: ProcessListMode) => void;
  onFullScreenChange: (open: boolean) => void;
  onSearch: (search: string) => void;
};

export const ListFilters = ({
  selected,
  onChange,
  fullScreen,
  onFullScreenChange,
  onSearch
}: ListFiltersProps) => {
  return (
    <S.ListFiltersRoot>
      <SearchInput onChange={onSearch} />

      <S.SwitchViewModeSection>
        <TableTreeButton
          selected={selected === "tree"}
          onClick={() => {
            onChange("tree");
          }}
        >
          <Tree />
        </TableTreeButton>

        <TableTreeButton
          selected={selected === "table"}
          onClick={() => {
            onChange("table");
          }}
        >
          <List />
        </TableTreeButton>
      </S.SwitchViewModeSection>

      {!fullScreen && (
        <TableTreeDefaultButton
          onClick={() => {
            onFullScreenChange(!fullScreen);
          }}
        >
          <Expand />
        </TableTreeDefaultButton>
      )}
    </S.ListFiltersRoot>
  );
};
